module.exports = __webpack_public_path__ + "static/media/WheatStage109.c827e848.PNG";